import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import PhoneInput from 'react-phone-input-2'
import Multiselect from 'multiselect-react-dropdown'
import 'react-phone-input-2/lib/style.css'
import {
  CButton,
  CCard,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CRow,
} from '@coreui/react'
import { GlobalContext } from '../../context/GlobalState'
import { LANGUAGES, TIME_ZONE } from '../../utils/constants'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { PERMISSIONS } from '../../utils/permissions'
import { checkPermissions } from '../../utils/helper'
import { isEmpty } from 'lodash'
import { AppContext } from 'src/views/context/app'
import { ACCOUNT_API, COUNTRY_API } from 'src/views/utils/urls'
import useAxios from 'axios-hooks'
import { capitalCase } from 'change-case'
import ChangePassword from '../userManagement/common/changePassword'
import RoleplayModal from './roleplayModal'

const CreateEditAccounts = ({ type }) => {
  const dispatch = useDispatch()
  const accountId = localStorage.getItem('accountId')
  const history = useHistory()
  const location = useLocation()

  const [studioName, setStudioName] = useState('')
  const [fullName, setFullName] = useState('')
  const [address, setAddress] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [domainName, setDomainName] = useState('')
  const [cloudFrontdomainName, setCloudFrontdomainName] = useState('')
  const [defaultEmail, setDefaultEmail] = useState('')
  const [timeZone, setTimeZone] = useState('')
  const [dateFormat, setDateFormat] = useState('DDMMYYYY')
  const [errorData, setErrorData] = useState({})
  const [disableContact, setDisableContact] = useState(false)
  const [editContactDisabled, setEditContactDisabled] = useState(true)
  const [masterCountry, setMasterCountry] = useState([])
  const [selectedCountry, setSelectedCountry] = useState([])
  const [selectedLanguage, setSelectedLanguage] = useState([])
  const [defaultLanguage, setDefaultLanguage] = useState('')
  const [accountMetadata, setAccountMetadata] = useState({
    title: '',
    description: '',
  })
  const [modulePermission, setModulePermission] = useState({})
  const [livePlan, setlivePlan] = useState('')
  const [customTemplateFlag, setCustomTemplateFlag] = useState(false)
  const [verifyEmail, setVerifyEmail] = useState(false)
  const [contentRefresh, setContentRefresh] = useState(false)
  const [transactionalEmailFlag, setTransactionalEmailFlag] = useState(false)
  const [marketingCRMFlag, setMarketingCRMFlag] = useState(false)
  const [enableDateRange, setEnableDateRange] = useState(false)
  const [geoBlock, setGeoBlock] = useState(false)
  const [playerPage, setPlayerPage] = useState(false)
  const [advanceComponentEdit, setAdvanceComponentEdit] = useState(false)
  const [distributionIds, setDistributionIds] = useState([])
  const [frontendDistributionId, setFrontendDistributionId] = useState('')
  const [tfeWorkspaceId, setTfeWorkspaceId] = useState('')
  const [accountAlias, setAccountAlias] = useState('')
  const [allowedPlatforms, setAllowedPlatforms] = useState({})
  const [odResourceAllowances, setOdResourceAllowances] = useState({})
  const [metaData, setMetaData] = useState('')
  const { setLoader } = useContext(AppContext)
  const { userSessionObj, userObj } = useContext(GlobalContext)

  const [selectedUser, setSelectedUser] = useState({})
  const [changePasswordModal, setChangePasswordModal] = useState(false)
  const [roleplayModal, setRoleplayModal] = useState(false)

  let languageMaster = LANGUAGES.map((lang) => {
    let tempLang = lang
    tempLang[`displayName`] = `${lang.name} (${lang.nativeName})`
    return tempLang
  })

  const createAllowed = userObj.is_super_user
    ? true
    : checkPermissions(
        userSessionObj.session_data.permissions,
        PERMISSIONS.ACCOUNT_MANAGEMENT.CREATE,
      )

  const updateAllowed = userObj.is_super_user
    ? true
    : checkPermissions(
        userSessionObj.session_data.permissions,
        PERMISSIONS.ACCOUNT_MANAGEMENT.UPDATE,
      )

  const editAccountFlag = location.pathname === '/create-admin-accounts' && !isEmpty(location.state)

  const [{ data: userInfo, loading: userInfoLoading }, userInfoCall] = useAxios(
    {
      url: `${ACCOUNT_API}/detail`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createAdminUser, loading: createAdminUserLoading }, createAdminUserCall] =
    useAxios(
      {
        url: ACCOUNT_API,
        method: 'post',
      },
      { manual: true },
    )

  const [{ data: updateAdminUser, loading: updateAdminUserLoading }, adminUserUpdateCall] =
    useAxios(
      {
        url: ACCOUNT_API,
        method: 'put',
      },
      { manual: true },
    )

  const [{ data: countryList, loading: countryLoading }] = useAxios({
    url: COUNTRY_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(userInfoLoading || createAdminUserLoading || updateAdminUserLoading || countryLoading)
  }, [userInfoLoading, createAdminUserLoading, updateAdminUserLoading, countryLoading])

  useEffect(() => {
    if (userInfo && userInfo.success) {
      let temp = userInfo?.data
      setStudioName(temp.name)
      setFullName(temp.contact_person)
      setEmail(temp.contact_email)
      setDomainName(temp?.domain_name)
      setCloudFrontdomainName(temp?.cf_domain_name)
      setDefaultEmail(temp?.default_email)
      setAddress(temp.address)
      setPhoneNumber(temp.contact_phone)
      setTimeZone(temp.time_zone)
      setDateFormat(temp?.date_format)
      setSelectedCountry(temp.allowed_countries)
      setSelectedLanguage(temp.allowed_languages)
      setDistributionIds(temp.distribution_ids)
      setFrontendDistributionId(temp?.cf_frontend_id)
      setTfeWorkspaceId(temp?.tfe_workspace_id)
      setAccountAlias(temp.alias)

      setMetaData(temp?.meta_data)
      if (temp?.default_language) {
        setDefaultLanguage(temp?.default_language)
      }
      if (temp?.account_metadata) {
        setAccountMetadata(temp?.account_metadata)
      }
      setAllowedPlatforms(temp.allowed_platforms)
      setEditContactDisabled(true)
      setModulePermission(temp.module_permissions)
      if (temp?.od_resource_allowances?.live_plan) {
        setlivePlan(temp?.od_resource_allowances?.live_plan)
      }
      setOdResourceAllowances(temp?.od_resource_allowances)
      setVerifyEmail(temp?.od_resource_allowances?.verify_email ? true : false)
      setContentRefresh(temp?.od_resource_allowances?.content_refresh ? true : false)
      setCustomTemplateFlag(temp?.od_resource_allowances?.custom_template ? true : false)
      setTransactionalEmailFlag(temp?.od_resource_allowances?.transactional_email ? true : false)
      setMarketingCRMFlag(temp?.od_resource_allowances?.marketing_crm_integration ? true : false)
      setEnableDateRange(temp?.od_resource_allowances?.enable_date_range ? true : false)
      setGeoBlock(temp?.od_resource_allowances?.geo_block ? true : false)
      setPlayerPage(temp?.od_resource_allowances?.player_page ? true : false)
      setAdvanceComponentEdit(temp?.od_resource_allowances?.advance_component_edit ? true : false)
    }
  }, [userInfo])

  useEffect(() => {
    if (countryList && countryList.success) {
      setMasterCountry(countryList.data)
    }
  }, [countryList])

  useEffect(() => {
    if (createAdminUser && createAdminUser.success) {
      history.push('/manage-accounts')
    }
  }, [createAdminUser])

  useEffect(() => {
    if (updateAdminUser && updateAdminUser.success) {
      setEditContactDisabled(true)
      if (editAccountFlag) {
        history.push('/manage-accounts')
      }
    }
  }, [updateAdminUser])

  useEffect(() => {
    if (type === 'Basic') {
      userInfoCall()
    }
    if (type === 'accounts') {
      setEditContactDisabled(false)
      if (editAccountFlag) {
        const data = location.state
        setStudioName(data.name)
        setFullName(data.contact_person)
        setEmail(data.contact_email)
        setDomainName(data?.domain_name)
        setCloudFrontdomainName(data?.cf_domain_name)
        setDefaultEmail(data?.default_email)
        setAddress(data.address)
        setPhoneNumber(data.contact_phone)
        setTimeZone(data.time_zone)
        setDateFormat(data.date_format)
        setSelectedCountry(data.allowed_countries)
        setSelectedLanguage(data.allowed_languages)
        setDistributionIds(data.distribution_ids)
        setFrontendDistributionId(data?.cf_frontend_id)
        setTfeWorkspaceId(data?.tfe_workspace_id)
        setAccountAlias(data.alias)
        setAllowedPlatforms(data.allowed_platforms)
        setMetaData(data?.meta_data)
        if (data?.default_language) {
          setDefaultLanguage(data?.default_language)
        }
        if (data?.account_metadata) {
          setAccountMetadata(data?.account_metadata)
        }
        setModulePermission(data?.module_permissions)
        if (data?.od_resource_allowances?.live_plan) {
          setlivePlan(data?.od_resource_allowances?.live_plan)
        }
        setOdResourceAllowances(data?.od_resource_allowances)
        setVerifyEmail(data?.od_resource_allowances?.verify_email ? true : false)
        setContentRefresh(data?.od_resource_allowances?.content_refresh ? true : false)
        setCustomTemplateFlag(data?.od_resource_allowances?.custom_template ? true : false)
        setTransactionalEmailFlag(data?.od_resource_allowances?.transactional_email ? true : false)
        setMarketingCRMFlag(data?.od_resource_allowances?.marketing_crm_integration ? true : false)
        setEnableDateRange(data?.od_resource_allowances?.enable_date_range ? true : false)
        setGeoBlock(data?.od_resource_allowances?.geo_block ? true : false)
        setPlayerPage(data?.od_resource_allowances?.player_page ? true : false)
        setAdvanceComponentEdit(data?.od_resource_allowances?.advance_component_edit ? true : false)
      }
    }
  }, [])

  const handleSelectCountry = (info, type) => {
    handleClearError('selectedCountry')
    let temp = selectedCountry
    if (type === 'add' && temp.indexOf(info.name) === -1) {
      temp.push(info)
    } else if (type === 'remove') {
      temp = temp.filter((ele) => ele.name !== info.name)
    }
    setSelectedCountry(temp)
  }

  const handleSelectLanguage = (info, type) => {
    handleClearError('selectedLanguage')
    let temp = selectedLanguage
    if (type === 'add' && temp.indexOf(info.code) === -1) {
      temp.push(info)
    } else if (type === 'remove') {
      temp = temp.filter((ele) => ele.code !== info.code)
    }
    setSelectedLanguage(temp)
  }

  const handleChangePassword = (info) => {
    setChangePasswordModal(true)
  }

  const validateInfo = (functionName) => {
    let isFormValid = true
    let temp = {}
    let basicFlag = type === 'Basic'
    if (functionName === 'contact') {
      if (studioName.trim().length === 0) {
        isFormValid = false
        temp.studioName = 'Account Name Cannot be Empty!'
      }
      if (basicFlag && isEmpty(fullName)) {
        isFormValid = false
        temp.fullName = 'Contact Name Cannot be Empty!'
      }
      if (basicFlag && isEmpty(phoneNumber)) {
        isFormValid = false
        temp.phoneNumber = 'Phone Cannot be Empty!'
      }
      if (basicFlag && isEmpty(timeZone)) {
        isFormValid = false
        temp.timeZone = 'Select Timezone!'
      }
      if (isEmpty(selectedCountry)) {
        isFormValid = false
        temp.selectedCountry = 'Select Country!'
      }
      if (basicFlag && isEmpty(accountMetadata.title)) {
        isFormValid = false
        temp.accountMetadata = 'Enter Meta Title!'
      }
      if (basicFlag && isEmpty(defaultLanguage)) {
        isFormValid = false
        temp.defaultLanguage = 'Select Default Language!'
      }
      if (!basicFlag && isEmpty(selectedLanguage)) {
        isFormValid = false
        temp.selectedLanguage = 'Select Language!'
      }
      if (!basicFlag && isEmpty(email)) {
        isFormValid = false
        temp.email = 'Fill Email!'
      }
      if (!basicFlag && isEmpty(domainName)) {
        isFormValid = false
        temp.domainName = 'Fill Domain Name!'
      }
    }
    setErrorData({ ...temp })
    return isFormValid
  }

  const handleClearError = (field) => {
    if (errorData && errorData[field]) {
      errorData[field] = ''
    }
  }

  const handleUpdateContact = async (event) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    event.preventDefault()
    setDisableContact(true)

    if (validateInfo('contact')) {
      const data = {
        name: studioName,
        alias: accountAlias,
        contact_person: fullName,
        contact_email: email,
        domain_name: domainName,
        cf_domain_name: cloudFrontdomainName,
        contact_phone: phoneNumber,
        address: address,
        time_zone: timeZone,
        date_format: dateFormat,
        allowed_countries: selectedCountry,
        allowed_languages: selectedLanguage,
        allowed_platforms: allowedPlatforms,
        default_email: defaultEmail,
        distribution_ids: distributionIds,
        cf_frontend_id: frontendDistributionId,
        tfe_workspace_id: tfeWorkspaceId,
        default_language:
          selectedLanguage.length === 1 ? selectedLanguage[0].code : defaultLanguage,
        account_metadata: accountMetadata,
        module_permissions: modulePermission,
        od_resource_allowances: {
          ...odResourceAllowances,
          live_plan: modulePermission?.live ? livePlan : '',
          custom_template: customTemplateFlag,
          verify_email: verifyEmail,
          content_refresh: contentRefresh,
          transactional_email: transactionalEmailFlag,
          marketing_crm_integration: marketingCRMFlag,
          enable_date_range: enableDateRange,
          geo_block: geoBlock,
          player_page: playerPage,
          advance_component_edit: advanceComponentEdit,
        },
        meta_data: metaData,
      }

      adminUserUpdateCall({
        params: {
          account_id: editAccountFlag ? location.state._id : accountId,
        },
        data,
      })
    }
    setDisableContact(false)
  }

  const handleCreateAdmin = async (event) => {
    if (!createAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    event.preventDefault()
    setDisableContact(true)

    if (validateInfo('contact')) {
      let payload = {
        name: studioName,
        alias: accountAlias,
        contact_person: fullName,
        contact_email: email,
        domain_name: domainName,
        cf_domain_name: cloudFrontdomainName,
        contact_phone: phoneNumber,
        address: address,
        time_zone: timeZone,
        date_format: dateFormat,
        default_email: defaultEmail,
        allowed_countries: selectedCountry,
        allowed_languages: selectedLanguage,
        allowed_platforms: allowedPlatforms,
        default_language:
          selectedLanguage.length === 1 ? selectedLanguage[0].code : defaultLanguage,
        account_metadata: accountMetadata,
      }
      createAdminUserCall({
        data: payload,
      })
    }
    setDisableContact(false)
  }

  const handlePermissionChange = (key, event) => {
    const { checked } = event.target

    let temp = modulePermission
    temp[`${key}`] = checked
    setModulePermission({ ...temp })
  }

  const handlePlatformChange = (key, subKey, event) => {
    const { checked } = event.target
    if (!isEmpty(subKey)) {
      setAllowedPlatforms((allowedPlatforms) => ({
        ...allowedPlatforms,
        [key]: { ...allowedPlatforms[key], [subKey]: checked },
      }))
    } else {
      setAllowedPlatforms((allowedPlatforms) => ({ ...allowedPlatforms, [key]: checked }))
    }
  }

  return (
    <CForm>
      <CCard style={{ padding: '20px' }}>
        <div className="d-flex justify-content-center align-items-center relative">
          <h5>Account Information</h5>
          {type !== 'Basic' && (
            <CButton
              onClick={() => setRoleplayModal(true)}
              color="info"
              className="text-white absolute right-0"
            >
              Roleplay
            </CButton>
          )}
        </div>

        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Account Name*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              placeholder=""
              value={studioName}
              onChange={(e) => {
                handleClearError('studioName')
                setStudioName(e.target.value)
              }}
              disabled={editContactDisabled}
            />
            <div className="message-text error-message">
              <p>{errorData.studioName}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Account Alias*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              placeholder=""
              value={accountAlias}
              onChange={(e) => {
                handleClearError('accountAlias')
                setAccountAlias(e.target.value)
              }}
              disabled={editContactDisabled}
            />
            <div className="message-text error-message">
              <p>{errorData.accountAlias}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Contact Name*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              placeholder=""
              value={fullName}
              onChange={(e) => {
                handleClearError('fullName')
                setFullName(e.target.value)
              }}
              disabled={editContactDisabled}
            />
            <div className="message-text error-message">
              <p>{errorData.fullName}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Contact Email*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                handleClearError('email')
                setEmail(e.target.value)
              }}
              value={email}
              placeholder=""
              disabled={type === 'Basic'}
            />
            <div className="message-text error-message">
              <p>{errorData.email}</p>
            </div>
          </CCol>
          <CCol xs="3">
            <CButton onClick={() => handleChangePassword()} color="info" className="text-white">
              Change Password
            </CButton>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Domain Name*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                handleClearError('domainName')
                setDomainName(e.target.value)
              }}
              value={domainName}
              placeholder=""
              disabled={type === 'Basic'}
            />
            <div className="message-text error-message">
              <p>{errorData.domainName}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Cloudfront Domain*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                handleClearError('cloudFrontdomainName')
                setCloudFrontdomainName(e.target.value)
              }}
              value={cloudFrontdomainName}
              placeholder=""
              disabled={type === 'Basic'}
            />
            <div className="message-text error-message">
              <p>{errorData.cloudFrontdomainName}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Distribution Ids*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                setDistributionIds(e.target.value.split(','))
              }}
              value={distributionIds.join(',')}
              placeholder=""
              disabled={type === 'Basic'}
            />
            <div className="message-text error-message">
              <p>{errorData.cloudFrontdomainName}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Frontend Distribution Id*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                setFrontendDistributionId(e.target.value)
              }}
              value={frontendDistributionId}
              placeholder=""
              disabled={type === 'Basic'}
            />
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Workspace Id*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                setTfeWorkspaceId(e.target.value)
              }}
              value={tfeWorkspaceId}
              placeholder=""
              disabled={type === 'Basic'}
            />
          </CCol>
        </CRow>
      </CCard>
      <CCard style={{ padding: '20px', marginTop: '10px' }}>
        <h5 style={{ textAlign: 'center' }}>Contact Info</h5>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Default Email(For communication)*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                setDefaultEmail(e.target.value)
              }}
              value={defaultEmail}
              placeholder=""
              disabled={type === 'Basic'}
            />
          </CCol>
        </CRow>

        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Address</CFormLabel>
          </CCol>
          <CCol>
            <CFormTextarea
              rows="2"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              disabled={editContactDisabled}
            />
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Phone*</CFormLabel>
          </CCol>
          <CCol>
            <PhoneInput
              country={'us'}
              value={phoneNumber}
              onChange={(phone) => {
                handleClearError('phoneNumber')
                setPhoneNumber(phone)
              }}
              disabled={editContactDisabled}
            />
            <div className="message-text error-message">
              <p>{errorData.phoneNumber}</p>
            </div>
          </CCol>
        </CRow>
      </CCard>
      <CCard style={{ padding: '20px', marginTop: '10px' }}>
        <h5 style={{ textAlign: 'center' }}>Meta Data</h5>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Meta Title*</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                handleClearError('accountMetadata')
                setAccountMetadata({ ...accountMetadata, title: e.target.value })
              }}
              value={accountMetadata?.title}
              placeholder=""
              disabled={editContactDisabled}
            />
            <div className="message-text error-message">
              <p>{errorData.accountMetadata}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Meta Description</CFormLabel>
          </CCol>
          <CCol>
            <CFormInput
              type="text"
              onChange={(e) => {
                setAccountMetadata({ ...accountMetadata, description: e.target.value })
              }}
              value={accountMetadata?.description}
              placeholder=""
              disabled={editContactDisabled}
            />
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Select Languages*</CFormLabel>
          </CCol>
          <CCol>
            <Multiselect
              options={type !== 'Basic' ? languageMaster : []} // Options to display in the dropdown
              selectedValues={type === 'Basic' || editAccountFlag ? selectedLanguage : null}
              style={{
                searchBox: {
                  background: 'white',
                },
              }}
              showCheckbox="true"
              onSelect={(e, info) => handleSelectLanguage(info, 'add')}
              onRemove={(e, info) => handleSelectLanguage(info, 'remove')}
              disablePreSelectedValues={type === 'Basic'}
              displayValue="displayName" // Property name to display in the dropdown options
            />
            <div className="message-text error-message">
              <p>{errorData.selectedLanguage}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Default Language*</CFormLabel>
          </CCol>
          <CCol>
            <CFormSelect
              value={defaultLanguage}
              onChange={(e) => {
                setDefaultLanguage(e.target.value)
                // handleClearError('timeZone')
              }}
              disabled={type === 'Basic'}
            >
              <option value="" disabled>
                Select Default Language
              </option>
              {selectedLanguage.map((obj, index) => (
                <option key={index} value={obj.code}>
                  {obj.displayName}
                </option>
              ))}
            </CFormSelect>
            <div className="message-text error-message">
              <p>{errorData.defaultLanguage}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Select Countries*</CFormLabel>
          </CCol>
          <CCol>
            <Multiselect
              options={!editContactDisabled ? masterCountry : []} // Options to display in the dropdown
              selectedValues={type === 'Basic' || editAccountFlag ? selectedCountry : null}
              style={{
                // chips: {
                //   background: '#fff',
                //   color: '#1976d2',
                //   border: '1px solid #1976d2',
                // },
                searchBox: {
                  background: 'white',
                },
              }}
              showCheckbox="true"
              onSelect={(e, info) => handleSelectCountry(info, 'add')}
              onRemove={(e, info) => handleSelectCountry(info, 'remove')}
              disablePreSelectedValues={editContactDisabled}
              displayValue="name" // Property name to display in the dropdown options
            />
            <div className="message-text error-message">
              <p>{errorData.selectedCountry}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Time Zone*</CFormLabel>
          </CCol>
          <CCol>
            <CFormSelect
              value={timeZone}
              onChange={(e) => {
                setTimeZone(e.target.value)
                handleClearError('timeZone')
              }}
              disabled={editContactDisabled}
            >
              <option value="" disabled>
                .........................TIME ZONE...............................
              </option>
              {TIME_ZONE.map((obj, index) => (
                <option key={index} value={obj.value}>
                  {obj.name}
                </option>
              ))}
            </CFormSelect>
            <div className="message-text error-message">
              <p>{errorData.timeZone}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Date Format*</CFormLabel>
          </CCol>
          <CCol xs="3">
            <CFormSelect
              value={dateFormat}
              onChange={(e) => {
                setDateFormat(e.target.value)
                // handleClearError('timeZone')
              }}
              disabled={editContactDisabled}
            >
              <option value={'DDMMYYYY'}>DD/MM/YYYY</option>
              <option value={'MMDDYYYY'}>MM/DD/YYYY</option>
              <option value={'YYYYMMDD'}>YYYY/MM/DD</option>
              <option value={'YYYYDDMM'}>YYYY/DD/MM</option>
            </CFormSelect>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol xs="3">
            <CFormLabel>Meta Data</CFormLabel>
          </CCol>
          <CCol>
            <CCol>
              <CFormTextarea
                rows="2"
                value={metaData}
                onChange={(e) => setMetaData(e.target.value)}
                disabled={editContactDisabled}
              />
            </CCol>
          </CCol>
        </CRow>
      </CCard>

      {type !== 'Basic' && !editContactDisabled && (
        <CCard style={{ padding: '20px', marginTop: '10px' }}>
          <h5 style={{ textAlign: 'center' }}>Allowed Platforms</h5>
          <CRow className="justify-content-c">
            <CCol className="border p-3" lg="6">
              Website
            </CCol>
            <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
              <CFormCheck
                defaultChecked={allowedPlatforms?.website}
                onChange={(e) => handlePlatformChange('website', '', e)}
              />
            </CCol>
          </CRow>
          <h6 style={{ textAlign: 'center' }} className="mt-4 mb-2">
            Mobile Apps
          </h6>
          <CRow className="justify-content-c">
            <CCol className="border p-3" lg="6">
              Android
            </CCol>
            <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
              <CFormCheck
                defaultChecked={allowedPlatforms?.mobile?.android}
                onChange={(e) => handlePlatformChange('mobile', 'android', e)}
              />
            </CCol>
          </CRow>
          <CRow className="justify-content-c">
            <CCol className="border p-3" lg="6">
              Ios
            </CCol>
            <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
              <CFormCheck
                defaultChecked={allowedPlatforms?.mobile?.ios}
                onChange={(e) => handlePlatformChange('mobile', 'ios', e)}
              />
            </CCol>
          </CRow>
          <h6 style={{ textAlign: 'center' }} className="mt-4 mb-2">
            TV Apps
          </h6>
          <CRow className="justify-content-c">
            <CCol className="border p-3" lg="6">
              Android
            </CCol>
            <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
              <CFormCheck
                defaultChecked={allowedPlatforms?.tv?.android}
                onChange={(e) => handlePlatformChange('tv', 'android', e)}
              />
            </CCol>
          </CRow>
          <CRow className="justify-content-c">
            <CCol className="border p-3" lg="6">
              Ios
            </CCol>
            <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
              <CFormCheck
                defaultChecked={allowedPlatforms?.tv?.ios}
                onChange={(e) => handlePlatformChange('tv', 'ios', e)}
              />
            </CCol>
          </CRow>
          <CRow className="justify-content-c">
            <CCol className="border p-3" lg="6">
              Roku TV
            </CCol>
            <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
              <CFormCheck
                defaultChecked={allowedPlatforms?.tv?.roku}
                onChange={(e) => handlePlatformChange('tv', 'roku', e)}
              />
            </CCol>
          </CRow>
        </CCard>
      )}

      {type !== 'Basic' && !editContactDisabled && (
        <CCard style={{ padding: '20px', marginTop: '10px' }}>
          <h5 style={{ textAlign: 'center' }}>Module Permission</h5>
          {modulePermission &&
            Object.keys(modulePermission).map((key, index) => (
              <CRow key={index} className="justify-content-c">
                <CCol className="border p-3" lg="6">
                  {capitalCase(key)}
                </CCol>

                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={modulePermission[`${key}`]}
                    onChange={(e) => handlePermissionChange(key, e)}
                  />
                  {key === 'live' && (
                    <CFormSelect
                      value={livePlan}
                      onChange={(e) => {
                        setlivePlan(e.target.value)
                      }}
                      disabled={type === 'Basic'}
                      className="mx-4 w-25"
                      size="sm"
                    >
                      <option value="" disabled>
                        Live Plan
                      </option>
                      <option value={'c1_720'}>720P</option>
                      <option value={'c1_1080'}>1080P</option>
                      <option value={'c1_2160'}>2160P</option>
                    </CFormSelect>
                  )}
                </CCol>
              </CRow>
            ))}
          {type !== 'Basic' && (
            <>
              <h5 style={{ textAlign: 'center' }} className="mt-4 mb-2">
                Other Permission
              </h5>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Custom Template
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={customTemplateFlag}
                    value={customTemplateFlag}
                    onChange={(e) => setCustomTemplateFlag(e.target.checked)}
                  />
                </CCol>
              </CRow>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Verify Email
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={verifyEmail}
                    value={verifyEmail}
                    onChange={(e) => setVerifyEmail(e.target.checked)}
                  />
                </CCol>
              </CRow>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Content Refresh
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={contentRefresh}
                    value={contentRefresh}
                    onChange={(e) => setContentRefresh(e.target.checked)}
                  />
                </CCol>
              </CRow>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Transactional Email
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={transactionalEmailFlag}
                    value={transactionalEmailFlag}
                    onChange={(e) => setTransactionalEmailFlag(e.target.checked)}
                  />
                </CCol>
              </CRow>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Marketing CRM Integration
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={marketingCRMFlag}
                    value={marketingCRMFlag}
                    onChange={(e) => setMarketingCRMFlag(e.target.checked)}
                  />
                </CCol>
              </CRow>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Enable Date Range
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={enableDateRange}
                    value={enableDateRange}
                    onChange={(e) => setEnableDateRange(e.target.checked)}
                  />
                </CCol>
              </CRow>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Geo Blocking
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={geoBlock}
                    value={geoBlock}
                    onChange={(e) => setGeoBlock(e.target.checked)}
                  />
                </CCol>
              </CRow>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Player Page
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={playerPage}
                    value={playerPage}
                    onChange={(e) => setPlayerPage(e.target.checked)}
                  />
                </CCol>
              </CRow>
              <CRow className="">
                <CCol className="border p-3" lg="6">
                  Allow Advance Component Edit
                </CCol>
                <CCol className="border p-3 flex" lg="6" style={{ alignItems: 'center' }}>
                  <CFormCheck
                    defaultChecked={advanceComponentEdit}
                    value={advanceComponentEdit}
                    onChange={(e) => setAdvanceComponentEdit(e.target.checked)}
                  />
                </CCol>
              </CRow>
            </>
          )}
        </CCard>
      )}
      <CRow className="mt-4 justify-content-lg-end">
        <CCol lg={1}>
          {editContactDisabled ? (
            <CButton
              color="info"
              className="px-4 text-white"
              onClick={() => setEditContactDisabled(false)}
              disabled={!updateAllowed || disableContact}
            >
              Edit
            </CButton>
          ) : (
            <CButton
              color="info"
              className="px-4 text-white"
              onClick={
                type === 'Basic' || editAccountFlag ? handleUpdateContact : handleCreateAdmin
              }
              disabled={!updateAllowed || disableContact}
            >
              {type === 'Basic' ? `Update` : editAccountFlag ? `Update` : `Create`}
            </CButton>
          )}
        </CCol>
      </CRow>
      {changePasswordModal && (
        <ChangePassword
          user={selectedUser}
          showModal={changePasswordModal}
          handleClose={() => setChangePasswordModal(false)}
        />
      )}
      {roleplayModal && (
        <RoleplayModal accountId={location.state._id} onClose={() => setRoleplayModal(false)} />
      )}
    </CForm>
  )
}

export default CreateEditAccounts
